export default "__VITE_ASSET__CeDbR$OK__"